import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { SkinColor } from "./avatars";
import { ColorButton } from "./colorButton";
export function SkinButton({ isSelected, skin, onClick, }) {
    const color = useMemo(() => SkinColor[skin], [skin]);
    return (_jsx(ColorButton, { color: color, isSelected: isSelected, onClick: onClick }));
}
